<template>
	<div>
		<h2 v-if="withApplicantName">{{ applicantName }}</h2>
		<FormGroup
			label="Wähle bitte aus:"
			:state="exclusionTypeValid"
			class="mt-3"
			:label-classes="['font-weight-bold']"
		>
			<div class="d-flex">
				<b-form-radio
					v-model="exclusionType"
					:value="exclusionTypes.job"
					name="customer-send-off"
					@change="exclusionTypeChanged(exclusionTypes.job)"
				>
					<div class="font-weight-extra-bold">
						Für diesen Job von <span class="color-primary">{{ applicantName }}</span> verabschieden,
						andere Jobs sind möglich
					</div>
					<div>
						Nur für diesen Job von dieser Person verabschieden, aber für eine anderen Job könnte eine
						Zusammenarbeit mit dieser Person möglich sein.
					</div>
				</b-form-radio>
			</div>
			<div class="d-flex mt-3">
				<b-form-radio
					v-model="exclusionType"
					:value="exclusionTypes.jobTemporary"
					name="customer-send-off"
					@change="exclusionTypeChanged(exclusionTypes.jobTemporary)"
				>
					<div class="font-weight-extra-bold">
						Nur vorläufig für diesen Job von <span class="color-primary">{{ applicantName }}</span>
						verabschieden, später wieder möglich
					</div>
					<div>
						Aktuell für diesen Job verabschieden, aber eventuell ist später für diesen oder einen sehr
						ähnlichen Job eine Zusammenarbeit mit dieser Person denkbar und interessant.
					</div>
					<FormGroup
						v-if="exclusionTypeValidUntilMonthsEligible"
						label="In wie vielen Monaten ist eine Zusammenarbeit wieder denkbar? Die Person wird dir nach den ausgewählten Monaten wieder angezeigt, sollte sie dann verfügbar und interessiert sein."
						:state="exclusionTypeValidUntilMonthsValid"
						class="my-2"
					>
						<Select
							v-model="exclusionTypeValidUntilMonths"
							:options="validUntilOptions"
							@change="emitChangeEvent"
						/>
					</FormGroup>
				</b-form-radio>
			</div>
			<div class="d-flex mt-3">
				<b-form-radio
					v-model="exclusionType"
					:value="exclusionTypes.total"
					name="customer-send-off"
					@change="exclusionTypeChanged(exclusionTypes.total)"
				>
					<div class="font-weight-extra-bold">
						Vollständig von <span class="color-primary">{{ applicantName }}</span> verabschieden
					</div>
					<div>
						Für alle derzeitigen und zukünftigen Jobs von dieser Person verabschieden. Du kannst diese
						Auswahl später wieder ändern und danach die Person wieder kontaktieren, sollte diese dann
						verfügbar und interessiert sein.
					</div>
				</b-form-radio>
			</div>
		</FormGroup>
		<JonInfo v-if="isAnonymous" class="mt-3">
			<template #message>
				<p>Die Person erhält eine enstprechende Mitteilung und erfährt derzeit weder deinen Namen noch den Namen
					eurer Organisation/Firma.</p>
				<p>Verabschiedete Personen findest du unter "Verabschiedungen".</p>
			</template>
		</JonInfo>
	</div>
</template>

<script>
import FormGroup from "@/vue/common/form/Group";
import Select from "@/vue/common/form/Select";
import {isDefined} from "@/helper/Value";
import _ from "lodash";
import InfoBox from "@/vue/common/InfoBox.vue";
import JonInfo from "@/vue/common/JonInfo.vue";

const EXCLUSION_TYPE_JOB = 'job';
const EXCLUSION_TYPE_JOB_TEMPORARY = 'job-temporary';
const EXCLUSION_TYPE_TOTAL = 'total';

export default {

	components: {
		JonInfo,
		InfoBox,
		Select,
		FormGroup,
	},

	props: {
		disclosedData: {
			type: Object,
			required: false,
		},
		pseudonym: {
			type: Object,
			required: false,
		},
		withApplicantName: {
			type: Boolean,
			required: false,
			default: true
		},
		isAnonymous: {
			type: Boolean,
			required: false,
			default: false
		},
	},

	data ()
	{
		return {
			exclusionType: undefined,
			exclusionTypes: {
				job: EXCLUSION_TYPE_JOB,
				jobTemporary: EXCLUSION_TYPE_JOB_TEMPORARY,
				total: EXCLUSION_TYPE_TOTAL,
			},
			exclusionTypeValidUntilMonths: undefined,
		};
	},

	computed: {
		validUntilOptions ()
		{
			return _.map(
				_.range(1, 13),
				month =>
				{
					return {
						value: month,
						text: month + ' ' + (month === 1 ? 'Monat' : 'Monate')
					};
				}
			);
		},
		applicantName ()
		{
			return this.disclosedData?.name || this.pseudonym.label;
		},
		exclusionTypeValid ()
		{
			return isDefined(this.exclusionType);
		},
		exclusionTypeValidUntilMonthsEligible ()
		{
			return this.exclusionType === EXCLUSION_TYPE_JOB_TEMPORARY;
		},
		exclusionTypeValidUntilMonthsValid ()
		{
			return !this.exclusionTypeValidUntilMonthsEligible || isDefined(this.exclusionTypeValidUntilMonths);
		},
		dataValid ()
		{
			return this.exclusionTypeValid
				&& this.exclusionTypeValidUntilMonthsValid;
		}
	},

	methods: {
		exclusionTypeChanged (exclusionType)
		{
			this.exclusionType = exclusionType;

			this.emitChangeEvent();
		},
		emitChangeEvent ()
		{
			if (!this.dataValid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', {
				exclusionType: this.exclusionType,
				exclusionTypeValidUntilMonths: this.exclusionTypeValidUntilMonthsEligible
					? this.exclusionTypeValidUntilMonths
					: undefined,
			});
		}
	}
}
</script>
